import { motion, AnimatePresence } from 'framer-motion';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import ProblemSection from '../components/ProblemSection';
import BotFeatures from '../components/BotFeatures';
import HowItWorks from '../components/HowItWorks';
import WhoThisIsFor from '../components/WhoThisIsFor';
import WhyTradersCouncil from '../components/WhyTradersCouncil';
import CTASection from '../components/CTASection';
import FAQSection from '../components/FAQSection';
import Footer from '../components/Footer';
import StickyMobileCTA from '../components/StickyMobileCTA';
import QuizModal from '../components/QuizModal';
import { useGateModal } from '../hooks/useGateModal';

const LandingPage = () => {
  const { isOpen, closeGate } = useGateModal();

  return (
    <div className="relative min-h-screen bg-tc-bg" data-testid="landing-page">
      {/* Seamless Background Image */}
      <div 
        className="fixed inset-0 z-0 pointer-events-none opacity-20 mix-blend-screen"
        style={{
          backgroundImage: `url('/images/backgrounds/landing_page_bg_1774768141088.png')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed'
        }}
      />
      
      {/* Content Overlay */}
      <div className="relative z-10 container-overlay">
        <Navbar />
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          <Hero />
          <ProblemSection />
          <BotFeatures />
          <HowItWorks />
          <WhoThisIsFor />
          <WhyTradersCouncil />
          <CTASection />
          <FAQSection />
          <Footer />
        </motion.div>

        <StickyMobileCTA />

        <AnimatePresence>
          {isOpen && <QuizModal onClose={closeGate} />}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default LandingPage;
